import { getFirestore } from 'firebase/firestore/lite';
import {
  getAnalytics,
  setAnalyticsCollectionEnabled,
} from 'firebase/analytics';
import { getStorage } from 'firebase/storage';

import { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';

import {
  AnalyticsProvider,
  FirestoreProvider,
  useFirebaseApp,
  useInitAnalytics,
  StorageProvider,
} from 'reactfire';
import React from 'react';

import { environment } from '../environments/environment';

export function FirebaseProviders({ children }) {
  const app = useFirebaseApp();
  const firestoreInstance = getFirestore(app);
  const storage = getStorage(app);
  const isDev = !environment.production;
  console.log({ isDev });

  const { data: analitycsInstance } = useInitAnalytics(async (firebaseApp) => {
    const analitycs = getAnalytics(firebaseApp);
    if (isDev) {
      setAnalyticsCollectionEnabled(analitycs, false);
    }
    return analitycs;
  });

  useEffect(() => {
    setTimeout(() => {
      ReactPixel.init('409503237237428', null, {
        autoConfig: true,
        debug: true,
      });
      ReactPixel.pageView();
    }, 3000);
  }, []);

  return (
    <AnalyticsProvider sdk={analitycsInstance}>
      <FirestoreProvider sdk={firestoreInstance}>
        <StorageProvider sdk={storage}>{children}</StorageProvider>
      </FirestoreProvider>
    </AnalyticsProvider>
  );
}
